import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EventosService, StateTag } from 'src/app/services/eventos.service';
import SwiperCore, { Pagination, Navigation } from 'swiper';
import { ComentariosService } from 'src/app/services/comentarios.service';
import { MapsService } from 'src/app/services/maps.service';
import { HoursDatesEventComponent } from '../bloques/hours-dates-event/hours-dates-event.component';
import { MatDialog } from '@angular/material/dialog';
import { FavoritosService } from 'src/app/services/favoritos.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { AppSettings } from 'src/app/app-settings';
import { InfoCardComponent } from '../shared/info-card/info-card.component';
import { TicketsService } from 'src/app/services/tickets.service';
import { SubscriberFrontComponent } from '../subscriber-front/subscriber-front.component';
import { PrivateEventComponent } from '../bloques/private-event/private-event.component';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import { formatDate } from '@angular/common';
import { SessionsService } from 'src/app/services/sessions.service';
SwiperCore.use([Pagination, Navigation]);

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.scss'],
})
export class EventComponent implements OnInit {
  event!: any;
  slug!: string;
  fragment!: string;
  selectLugar: string;
  loaded: boolean = false;
  owner!: any;
  external!: boolean;

  // Aux
  today: any = new Date();
  imagesSwiper = [];
  urlImages: string = AppSettings.MEDIA_URI + '/events_images/';
  urlFiles: string = AppSettings.MEDIA_URI + '/events_files/';

  // Comments
  totalItems: number = 0;

  hashtags: any[] = [];
  sharedSupported: boolean = false;

  profile!: any;
  isAdmin: boolean = false;
  adminCitylok: boolean = false;
  isGestor: boolean = false;
  isWishlist: boolean = false;
  isLite: boolean = false;
  openExternal: boolean = false;
  widthContainer!: any;
  loading: boolean = true;
  imagenUrl: string = '../../../assets/img/image_default.png';
  pastEvent: boolean = false;
  organizer: boolean = false;
  userMe!: any;
  createdBy!: any;
  isPlace: boolean = false;
  venuesUser: any[] = [];
  isMember: boolean = false;
  isDraft: boolean = false;
  imageUrl: string = '';

  repeatEvent: boolean = false;
  viewTotem: boolean = AppSettings.ENV_TOTEM;
  viewGoogleMap: boolean = false;
  nextSession: any = null;
  linkCopied: boolean = false;

  /** La etiqueta del cartel (hoy / nuevo / lo está petando), calculada una vez */
  heroTag: StateTag | null = null;
  descriptionExpanded: boolean = false;
  /** Longitud a partir de la cual la descripción se recorta con «Leer más» */
  private readonly DESCRIPTION_CLAMP_CHARS = 340;

  /**
   * Próximas funciones agrupadas por día, para la fila del encabezado. La
   * sesión es la primera del día: con ella se abre el selector ya en esa fecha.
   */
  upcomingDates: { date: any; hours: string[]; session: any }[] = [];
  moreDatesCount: number = 0;
  private readonly MAX_UPCOMING_DATES = 5;
  /** Sesión con la que se abre el selector del panel de escritorio */
  preselectedSession: any = null;
  /** Sesión cuyo mapa se abre directamente desde la tarjeta (evento de una sola sesión) */
  directMapSession: any = null;
  openingDirectMap: boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private eventosService: EventosService,
    private meta: Meta,
    private title: Title,
    private router: Router,
    private comentarios: ComentariosService,
    private mapas: MapsService,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private ticketsService: TicketsService,
    private favoritos: FavoritosService,
    private auth: AuthenticationService,
    private sessionsService: SessionsService,
  ) { }

  /** El nombre del espacio, o nada si el evento solo trae dirección */
  get venueName(): string {
    return this.event?.space?.name || '';
  }

  /** La dirección de la calle, del espacio o del propio evento */
  get venueAddress(): string {
    return this.event?.space?.address || this.event?.address || this.event?.city?.name || '';
  }

  /**
   * Enlace a Google Maps para «Abrir en Maps»: con coordenadas si las hay,
   * porque la dirección escrita a mano falla más de lo que acierta.
   */
  get mapsUrl(): string {
    const lat = this.event?.latitude || this.event?.space?.latitude;
    const lng = this.event?.longitude || this.event?.space?.longitude;
    if (lat && lng) {
      return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
    }
    const place = [this.venueName, this.venueAddress, this.event?.city?.name]
      .filter((value) => !!value)
      .join(', ');
    if (!place) {
      return '';
    }
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(place)}`;
  }

  /**
   * Si la descripción da para recortarla. Se mide sobre el texto sin etiquetas
   * en vez de sobre la altura pintada: así no hace falta leer el DOM.
   */
  get descriptionIsLong(): boolean {
    const text: string = (this.event?.description || '').replace(/<[^>]*>/g, '');
    return text.length > this.DESCRIPTION_CLAMP_CHARS;
  }

  toggleDescription(): void {
    this.descriptionExpanded = !this.descriptionExpanded;
  }

  /**
   * Las próximas funciones agrupadas por día, para el encabezado. Se calcula
   * al cargar el evento y no en cada ciclo de la vista, que aquí se pinta
   * dentro del hero.
   */
  private buildUpcomingDates(): void {
    const sessions: any[] = (this.event?.sessions || []).filter(
      (session: any) => session.active !== false && new Date(session.start_date) >= new Date(),
    );
    const byDay = new Map<string, { date: any; hours: string[]; session: any }>();
    sessions
      .sort((a: any, b: any) => new Date(a.start_date).getTime() - new Date(b.start_date).getTime())
      .forEach((session: any) => {
        const key = formatDate(session.start_date, 'yyyy-MM-dd', 'es-ES', '+0000');
        const hour = formatDate(session.start_date, 'HH:mm', 'es-ES', '+0000');
        if (!byDay.has(key)) {
          byDay.set(key, { date: session.start_date, hours: [], session });
        }
        const day = byDay.get(key)!;
        if (!day.hours.includes(hour)) {
          day.hours.push(hour);
        }
      });
    const days = Array.from(byDay.values());
    // Con una sola función la fila no aporta nada: ya está en la fecha de arriba
    this.upcomingDates = days.length > 1 ? days.slice(0, this.MAX_UPCOMING_DATES) : [];
    this.moreDatesCount = Math.max(0, days.length - this.upcomingDates.length);
  }

  /**
   * Si las fechas del encabezado pueden abrir el selector. Son un atajo a lo
   * mismo que «Seleccionar entradas», así que se cierran en los mismos casos
   * en los que ese botón no deja comprar: venta sin abrir (Próximamente),
   * aforo completo, solo taquilla, venta cerrada o evento externo/informativo.
   */
  get datesOpenPicker(): boolean {
    const event = this.event;
    if (!event || event.informative || event.external || event.only_tpv_sales || event.sold_out) {
      return false;
    }
    if (this.eventosService.salesPending(event)) {
      return false;
    }
    return !event.end_sales || new Date(event.end_sales) > new Date();
  }

  /**
   * Abre el selector de sesión desde una fecha del encabezado, con esa fecha
   * ya seleccionada. «+N fechas» llega sin sesión y abre en la primera.
   *
   * El evento privado pide el código igual que el botón de compra, o la fila
   * de fechas sería la puerta de atrás para saltárselo.
   */
  openDatePicker(session: any = null): void {
    if (!this.datesOpenPicker) {
      return;
    }
    const open = () => this.openHoursEvent(true, session);
    if (!this.event.private_event) {
      open();
      return;
    }
    this.dialog
      .open(PrivateEventComponent, { panelClass: ['info-dialog', 'not-padding', 'info-abono-dialog'] })
      .afterClosed()
      .subscribe((code) => {
        if (!code) {
          return;
        }
        const wrongCode = () => this.openInfoDialog('Lo sentimos, el código es incorrecto.', true, false);
        this.eventosService.checkCodePrivateEvent(this.event.id, code).subscribe({
          next: (data: any) => (data.success ? open() : wrongCode()),
          error: () => wrongCode(),
        });
      });
  }

  ngOnInit(): void {
    this.widthContainer = window.innerWidth;
    const navigator = window.navigator as any;
    if (navigator.share) {
      this.sharedSupported = true;
    }
    this.profile = this.auth.profileStorage.pipe();
  }

  ngAfterViewInit() {
    this.activatedRoute.params.subscribe((params) => {
      let slug: string = params.slugEvent;
      if (!slug && location.href.indexOf('teatroideal') != -1) {
        slug = params.shortUrl;
      }
      if (!slug) {
        this.router.navigate(['/not-found']);
      }
      this.slug = slug;
      const firstIndex = slug.indexOf('-');
      let idEvent = slug.substring(0, firstIndex);

      this.eventosService.getEventById(idEvent).subscribe({
        next: (data) => {
          if (!data.success) {
            this.router.navigate(['/not-found']);
          }
          this.event = data.data;
          this.createdBy = data.data.company;
          this.computeYoutubeEmbedUrl();
          // En event.component.ts -> ngAfterViewInit

          this.auth.profileStorage.subscribe({
            next: (userData) => {
              if (userData) {
                const subscribedSpaceIds =
                  userData.space_subscriptions?.map((sub) => sub.space_id) ||
                  [];

                if (
                  this.event?.space?.id &&
                  subscribedSpaceIds.includes(this.event.space.id)
                ) {
                  this.isMember = true;
                } else {
                  this.isMember = false;
                }
              }
            },
          });
          if (this.event.image_url) {
            this.imageUrl = this.urlImages + this.event.image_url;
          }

          this.nextSession = this.sessionsService.getNextSession(this.event);
          this.event.nextSession = this.nextSession;

          // La misma etiqueta que la card del listado, con su mismo color.
          // Ordena las sesiones cada vez que se llama, así que se resuelve
          // aquí una sola vez en lugar de en cada ciclo de la vista.
          this.heroTag = this.eventosService.getStateTag(this.event);
          this.buildUpcomingDates();

          // Metaetiquetas
          const ogDescription = this.event.description
            ? this.event.description.replace(/<[^>]*>/g, '').substring(0, 200)
            : 'Disfruta del evento "' + this.event.title + '". ¡No te lo pierdas!';
          const ogImage = this.imageUrl || (AppSettings.FRONT + '/assets/img/image_default.png');

          this.title.setTitle('Citylok - ' + this.event.title);
          this.meta.updateTag({ name: 'description', content: ogDescription });

          // Open Graph
          this.meta.updateTag({ property: 'og:site_name', content: 'Citylok' });
          this.meta.updateTag({ property: 'og:title', content: 'Citylok - ' + this.event.title });
          this.meta.updateTag({ property: 'og:description', content: ogDescription });
          this.meta.updateTag({ property: 'og:image', content: ogImage });
          this.meta.updateTag({ property: 'og:image:alt', content: this.event.title });
          this.meta.updateTag({ property: 'og:url', content: location.href });
          this.meta.updateTag({ property: 'og:type', content: 'website' });
          this.meta.updateTag({ property: 'og:locale', content: 'es_ES' });

          // Twitter Card
          this.meta.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
          this.meta.updateTag({ name: 'twitter:site', content: '@citylok' });
          this.meta.updateTag({ name: 'twitter:title', content: 'Citylok - ' + this.event.title });
          this.meta.updateTag({ name: 'twitter:description', content: ogDescription });
          this.meta.updateTag({ name: 'twitter:image', content: ogImage });
          this.meta.updateTag({ name: 'twitter:image:alt', content: this.event.title });

          this.isPlace = data.place != null;
          let now = new Date();
          let next = new Date();
          let end = null;
          if (this.event.end_date) {
            end = new Date(this.event.end_date);
          }
          if (this.event.next_session) {
            let indexPoint = this.event.next_session.indexOf(':');
            let hour = this.event.next_session.substring(0, indexPoint);
            let minutes = this.event.next_session.substring(indexPoint + 1);
            next.setHours(+hour);
            next.setMinutes(+minutes);
            if (end) {
              end.setHours(+hour);
              end.setMinutes(+minutes);
            }
          } else {
            next.setHours(23);
            next.setMinutes(59);
            if (end) {
              end.setHours(23);
              end.setMinutes(59);
            }
          }
          // La fecha fin del evento corta a las 23:59, así que sin esta salvedad
          // una sesión de las 22:00 con la venta abierta hasta la 01:00 se daría
          // por pasada en cuanto cambia el día.
          if (((now >= next && !end) || (end && now >= end)) && !this.eventosService.hasSessionSaleExtended(this.event)) {
            this.pastEvent = true;
          }
          this.isAdmin = this.auth.getProfile()?.admin;
          this.adminCitylok = this.auth.getProfile()?.citylok;
          this.isLite = this.auth.getProfile()?.lite;
          // this.isGestor = this.auth.getProfile()?.gestor;
          // this.isGestor = this.auth.getProfile()?.roleFunctions.find((value) => value.company.id == this.event.company?.id);
          this.isGestor = false;
          let pathUrl = window.location.href;
          this.isDraft = pathUrl.indexOf('draft') != -1;
          if (
            !this.isDraft &&
            !this.event.publish &&
            (!this.auth.getProfile() ||
              this.auth.getProfile().id != this.event.company.id_user) &&
            !this.auth?.getProfile()?.citylok &&
            !this.isGestor
          ) {
            this.router.navigate(['/not-found']);
          }
          if (this.event.image_url) {
            this.imagenUrl = this.urlImages + this.event.image_url;
          }
          this.hashtags = this.event.hashtags;
          window.scrollTo(0, 0);
          let user = this.auth.getProfile();
          let index = data.favoritos?.findIndex(
            (value) => (value.id = user?.id),
          );
          if (data.favoritos && index != -1) {
            this.isWishlist = true;
          }

          const fechasActivas: any[] = this.event.sessions.filter(
            (value) => new Date(value.start_date) >= new Date(),
          );
          if (fechasActivas.length > 0) {
            // const horarios = data.sessions.filter(value => new Date(value.start_date) >= new Date());
            this.repeatEvent = fechasActivas[0].id_recurring_session;
          }

          this.external = this.event.external == false ? false : true;
          this.owner = this.event.company.id_user;
          this.imagesSwiper = this.event.images;
          const idCategory = this.event.id_category;
          const idCity = this.event.id_city;
          if (this.event.company.id_user == this.auth.getProfile()?.id) {
            this.organizer = true;
          } else {
            this.auth.getMyData().subscribe({
              next: (data) => {
                let organizerEvents = data?.organizerEvents?.map(
                  (value) => value.id,
                );
                if (organizerEvents?.includes(+idEvent)) {
                  this.organizer = true;
                }
              },
            });
          }

          this.meta.updateTag({
            property: 'event:start_time',
            content: String(next),
          });
          this.meta.updateTag({
            property: 'event:end_time',
            content: String(end),
          });
          this.meta.updateTag({
            property: 'event:location',
            content: this.event.address,
          });
          this.meta.updateTag({
            property: 'event:description',
            content: this.event.description,
          });

          this.loading = false;
          // Sin sesiones futuras el evento está pasado, salvo que quede alguna
          // sesión empezada que el fin de ventas todavía permita vender.
          if ((!this.nextSession && !this.eventosService.hasSessionSaleExtended(this.event)) || this.event.sessions.length <= 0) {
            this.pastEvent = true;
          }
        },
        error: (e) => this.router.navigate(['/not-found']),
      });

      const commentarios: string = params.comments;
      if (commentarios) {
        setTimeout(() => {
          document
            .getElementsByClassName('content-comments')[0]
            .scrollIntoView({ behavior: 'smooth' });
        }, 1000);
      }
    });
  }

  ngAfterContentChecked() {
    if (this.fragment) {
      this.goToScrollPage(this.fragment);
    }
  }

  editActiveEvent() {
    if (this.isAdmin || this.adminCitylok) {
      const dialogRef = this.dialog.open(InfoCardComponent, {
        panelClass: 'info-dialog',
        data: {
          icon: true,
          text: '¿Estás seguro de que desea desactivar el evento?',
          warning: true,
          btnCancel: true,
        },
      });
      dialogRef.afterClosed().subscribe((res) => {
        if (res) {
          this.eventosService
            .putEventos(this.event.id, { publish: !this.event.publish })
            .subscribe({
              next: (data) => {
                this.event.publish = !this.event.publish;
                this.openInfoDialog(
                  'Los cambios se han guardado correctamente.',
                  false,
                  false,
                );
              },
              error: () => {
                this.openInfoDialog(
                  '¡Vaya! Algo ha fallado, vuelve a intentarlo más tarde.',
                  true,
                  false,
                );
              },
            });
        }
      });
    }
  }

  openInfoDialog(msg: string, icon: boolean, btnCancel: boolean) {
    this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      data: {
        icon: icon,
        text: msg,
        btnCancel: btnCancel,
      },
    });
  }

  openNewSubscriber() {
    if (
      this.venuesUser.length > 0 &&
      this.venuesUser.includes(this.createdBy.id)
    ) {
      this.openInfoDialog('Ya eres miembro de este espacio.', false, false);
      return;
    }
    this.dialog
      .open(SubscriberFrontComponent, {
        panelClass: ['info-dialog', 'not-padding', 'dialog-subscribers'],
        data: {
          idPlace: this.event.space?.id,
          user: this.profile,
          place: this.event.space,
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.openInfoDialog(res.msg, false, false);
        }
      });
  }

  getIds(url: string) {
    if (url) {
      const index = url.lastIndexOf('/');
      return url.substring(index + 1);
    }
    return '';
  }

  // Links
  async shareEvent() {
    if (this.sharedSupported) {
      const shareData: any = {
        title: this.event.title,
        text: this.event.title,
        url: AppSettings.FRONT + '/event/' + this.event.id + '-' + this.event.title.replaceAll(' ', '-'),
      };

      navigator.share(shareData).catch((error) => {
        if (AppSettings.DEBUG) {
          console.error('Error sharing', error);
        }
      });
    }
  }

  goToScrollPage(idPage: string) {
    var height = document.getElementById(idPage).offsetTop - 30;
    window.scrollTo(0, height);
  }

  @HostListener('window:resize')
  getWidthContainer() {
    this.widthContainer = window.innerWidth;
    if (this.widthContainer < 1200) {
      this.openExternal = false;
    }
  }

  openMapEvent() {
    this.router.navigate([
      '/edit-event/map',
      this.event.mapEvent?.id,
      this.event.id,
    ]);
  }

  openMapDirectly(session: any) {
    if (this.directMapSession) {
      return;
    }
    this.directMapSession = { ...session };
    this.openingDirectMap = true;
  }

  onDirectMapState(state: 'opened' | 'closed' | 'unavailable') {
    this.openingDirectMap = false;
    if (state === 'opened') {
      return;
    }
    this.directMapSession = null;
    // La sesión ya no se puede vender tal cual (p. ej. pasado el corte de hoy):
    // se enseña el calendario, que es quien lo explica.
    if (state === 'unavailable') {
      this.openHoursEvent(true);
    }
  }

  openHoursEvent(emit: boolean, session: any = null) {
    // Copia nueva en cada clic: con el panel ya abierto, el cambio de
    // referencia es lo que le avisa de que salte a otra fecha (aunque se
    // repita la misma después de haber movido el calendario a mano).
    // Desde el botón de compra llega sin sesión y el panel abre en la primera.
    this.preselectedSession = session ? { ...session } : null;
    if (window.innerWidth > 1200) {
      this.openExternal = emit;
    } else {
      if (emit) {
        const dialogRef = this.dialog.open(HoursDatesEventComponent, {
          panelClass: 'hours-lok-dialog',
          disableClose: true,
          data: { event: this.event, organizer: this.organizer, preselectedSession: session },
        });
      } else {
        this.openExternal = emit;
        this.dialog.closeAll();
      }
    }
  }

  // Dates and tags Strings
  tagString(card: any) {
    return this.eventosService.getTagString(card);
  }

  tagIcon(card: any) {
    return this.eventosService.getTagIcon(card);
  }

  datesEquals(card: any) {
    let fechaCard = card.nextSession?.start_date;
    return this.eventosService.datesEquals(fechaCard);
  }

  getDateString() {
    // Para eventos finalizados no hay nextSession (solo busca sesiones futuras),
    // así que usamos la última sesión del evento como referencia de fecha/hora.
    const sessions = this.event.sessions || [];
    const session = this.event.nextSession ?? sessions[sessions.length - 1];
    // Si el evento no tiene ninguna sesión caemos en la fecha del propio evento,
    // si no la cadena se quedaría en "null - <fecha fin>".
    let fecha = session?.start_date ?? this.event?.start_date;
    let stringDate = 'Hoy';
    if (!fecha && !this.event?.end_date) {
      return '';
    }
    if (
      sessions.length > 1 &&
      fecha &&
      this.event?.end_date &&
      formatDate(
        fecha,
        'yyyy-mm-dd',
        'es-ES',
        '+0000',
      ) !== formatDate(this.event?.end_date, 'yyyy-mm-dd', 'es-ES', '+0000')
    ) {
      stringDate = 'Varias fechas disponibles';
    } else {
      let dateStart = this.eventosService.ConvertDateToStringFormat(
        fecha, 'EEE, dd MMMM'
      );
      let dateEnd = this.eventosService.ConvertDateToStringFormat(
        this.event.end_date, 'EEE, dd MMMM'
      );
      if (!this.datesEquals(this.event) && dateStart) {
        stringDate = dateStart;
      }
      if (dateEnd && dateStart && dateStart != dateEnd) {
        stringDate += ' - ' + dateEnd;
      } else if (!dateStart && dateEnd) {
        stringDate = dateEnd;
      }
      if (fecha) {
        const hoursEvent = this.event.nextSession
          ? sessions.filter(
              (val) => new Date(val.start_date) >= new Date(),
            )
          : [{ start_date: fecha }];
        let optionsHour = hoursEvent.sort((a: any, b: any) => {
          const dateA = new Date(a.start_date);
          const dateB = new Date(b.start_date);
          return (
            dateA.getHours() * 60 +
            dateA.getMinutes() -
            (dateB.getHours() * 60 + dateB.getMinutes())
          );
        });
        optionsHour.forEach((element) => {
          let date = new Date(element.start_date);
          let hour = formatDate(date, 'HH:mm', 'es-ES', '+0000');
          stringDate += ' | ' + hour + 'h';
        });
      }
    }
    return stringDate;
  }

  editFavorito() {
    this.isWishlist ? this.deleteFavorito() : this.addFavorito();
  }

  addFavorito() {
    if (this.profile) {
      this.favoritos.postFavoritos(this.event.id).subscribe((res) => {
        if (res) {
          this.isWishlist = true;
        }
      });
    } else {
      this.dialog.open(InfoCardComponent, {
        panelClass: 'info-dialog',
        data: {
          icon: false,
          text: 'Inicia sesión y empieza a guardar tus eventos favoritos',
          btnCancel: false,
        },
      });
    }
  }

  deleteFavorito() {
    if (this.profile) {
      this.favoritos.deleteFavorito(this.event.id).subscribe((res) => {
        if (res) {
          this.isWishlist = false;
        }
      });
    } else {
      this.dialog.open(InfoCardComponent, {
        panelClass: 'info-dialog',
        data: {
          icon: false,
          text: 'Inicia sesión y empieza a guardar tus eventos favoritos',
          btnCancel: false,
        },
      });
    }
  }

  shareSocialEvent(type: string) {
    const href = encodeURIComponent(location.href);
    const title = encodeURIComponent(this.event.title || '');
    const description = encodeURIComponent(
      (this.event.description || '').replace(/<[^>]*>/g, '').substring(0, 200)
    );
    const hashtags = Array.isArray(this.event.hashtags)
      ? encodeURIComponent(this.event.hashtags.map((h: any) => h.name || h).join(','))
      : '';
    const whatsappText = encodeURIComponent(
      (this.event.title || '') + '\n' + location.href
    );
    let typeOpen = '_blank';
    let url = '';
    switch (type) {
      case 'twitter':
        url = `https://x.com/intent/tweet?text=${title}&url=${href}&hashtags=${hashtags}`;
        break;
      case 'linkedin':
        url = `https://www.linkedin.com/sharing/share-offsite/?url=${href}`;
        break;
      case 'facebook':
        url = `https://www.facebook.com/sharer/sharer.php?u=${href}`;
        break;
      case 'whatsapp':
        url = `https://wa.me/?text=${whatsappText}`;
        break;
      case 'envelope':
        url = `mailto:?subject=${title}&body=${description}%0A%0A${href}`;
        typeOpen = '_self';
        break;
      case 'default':
        this.shareEvent();
        return;
    }
    window.open(url, typeOpen);
  }

  copyEventLink() {
    navigator.clipboard.writeText(location.href).then(() => {
      this.linkCopied = true;
      setTimeout(() => (this.linkCopied = false), 2000);
    });
  }

  youtubeEmbedUrl: any = null;
  youtubeThumbnailUrl: string | null = null;
  youtubePlayerActive = false;

  private computeYoutubeEmbedUrl() {
    const url: string = this.event?.youtube_url;
    this.youtubeEmbedUrl = null;
    this.youtubeThumbnailUrl = null;
    this.youtubePlayerActive = false;
    if (!url) return;
    let videoId: string | null = null;
    try {
      const parsed = new URL(url);
      if (parsed.hostname.includes('youtu.be')) {
        videoId = parsed.pathname.slice(1);
      } else {
        videoId = parsed.searchParams.get('v');
      }
    } catch {
      return;
    }
    if (!videoId) return;
    this.youtubeEmbedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://www.youtube.com/embed/${videoId}?autoplay=1`
    );
    this.youtubeThumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
  }

  activateYoutubePlayer() {
    this.youtubePlayerActive = true;
  }

  showGoogleMap() {
    this.viewGoogleMap = true;
    setTimeout(() => {
      const lat = this.event.latitude || this.event.space?.latitude;
      const lng = this.event.longitude || this.event.space?.longitude;
      const address = this.event.localizacion || this.event.address || this.event.space?.address;
      this.mapas
        .loadMaps(lat, lng, address)
        .then(() => {
          this.loading = false;
        });
    }, 500);
  }

  // ========== MÉTODOS PARA MOSTRAR ESTADO DEL EVENTO ==========
  // (Solo lectura - los cambios se hacen desde el panel de control)

  /**
   * Obtener el estado actual del evento como texto
   */
  getEventStateText(): string {
    // Normalizar valores (arrays vacíos se tratan como null)
    const cancelled = Array.isArray(this.event.cancelled) && this.event.cancelled.length === 0 ? null : this.event.cancelled;
    const soldOut = Array.isArray(this.event.sold_out) && this.event.sold_out.length === 0 ? null : this.event.sold_out;
    const active = Array.isArray(this.event.active) && this.event.active.length === 0 ? null : this.event.active;

    if (cancelled === true) {
      return 'Cancelado';
    } else if (soldOut === true) {
      return 'Aforo Completo';
    } else if (active === false) {
      return 'Desactivado';
    } else if (this.event.active_sales === false) {
      return 'Ventas Detenidas';
    }
    return 'Operativo';
  }

  /**
   * Verificar si hay un estado especial que mostrar
   */
  hasSpecialEventState(): boolean {
    // Normalizar valores
    const cancelled = Array.isArray(this.event.cancelled) && this.event.cancelled.length === 0 ? null : this.event.cancelled;
    const soldOut = Array.isArray(this.event.sold_out) && this.event.sold_out.length === 0 ? null : this.event.sold_out;
    const active = Array.isArray(this.event.active) && this.event.active.length === 0 ? null : this.event.active;

    return cancelled === true || 
           soldOut === true || 
           active === false ||
           this.event.active_sales === false;
  }

  /**
   * Obtener el icono para el estado del evento
   */
  getEventStateIcon(): string {
    // Normalizar valores
    const cancelled = Array.isArray(this.event.cancelled) && this.event.cancelled.length === 0 ? null : this.event.cancelled;
    const soldOut = Array.isArray(this.event.sold_out) && this.event.sold_out.length === 0 ? null : this.event.sold_out;
    const active = Array.isArray(this.event.active) && this.event.active.length === 0 ? null : this.event.active;

    if (cancelled === true) {
      return 'fa-ban';
    } else if (soldOut === true) {
      return 'fa-users';
    } else if (active === false) {
      return 'fa-eye-slash';
    } else if (this.event.active_sales === false) {
      return 'fa-pause';
    }
    return 'fa-check-circle';
  }
}

